import { render, staticRenderFns } from "./num-table-modal.vue?vue&type=template&id=8ba13cb6&"
import script from "./num-table-modal.vue?vue&type=script&lang=js&"
export * from "./num-table-modal.vue?vue&type=script&lang=js&"
import style0 from "./num-table-modal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports